import { render, staticRenderFns } from "./ApiHistoryDetail.vue?vue&type=template&id=00743e68&scoped=true"
import script from "./ApiHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ApiHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00743e68",
  null
  
)

export default component.exports